export default function PageContent({ children }) {
    return (
        <div className="state-pages__content">
            { children }
        </div>
    )
}